import React, { FC } from 'react';

import styles from './styles.module.css';

export type CardHeaderPropsType = {
  title: string;
  children?: React.ReactNode;
};

export const CardHeader: FC<CardHeaderPropsType> = ({ title, children }) => {
  return (
    <div className={styles.cardHeader}>
      <h2>{title}</h2>
      {children}
    </div>
  );
};

CardHeader.displayName = 'CardHeader';
